// tslint:disable
export enum TCSInsuranceType {
    /**
     * @description Pharmacy
     */
    Pharmacy = 1,
    /**
     * @description Medical
     */
    Medical = 2,
    /**
     * @description Medical / Pharmacy
     */
    Both = 3,
}
(TCSInsuranceType as any)['PHARMACY'] = 1;
(TCSInsuranceType as any)['MEDICAL'] = 2;
(TCSInsuranceType as any)['BOTH'] = 3;
